import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import home from "../images/home-btn.webp";
import slider2img from "../images/casino-new-btn.webp";
import slider3img from "../images/aviator-new-btn.webp";
import slider4img from "../images/sports-btn.webp";
import slider5img from "../images/live-casino-btn.webp";
import slider6img from "../images/jetx-btn.webp";
import slider7img from "../images/aviatrix-new-btn.webp";
import slider8img from "../images/fazi-btn.webp";
import slider9img from "../images/crash-games-btn.webp";
import slider10img from "../images/pragmatic-btn.webp";
import slider11img from "../images/jambo-league-btn.webp";
import slider12img from "../images/tada-btn.webp";
import slider13img from "../images/virtuals-btn.webp";
import slider14img from "../images/wazdan-btn.webp";
import slider15img from "../images/playson-btn.webp";
import darkhome from "../images/home-btn.webp";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

const Slidersection = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { isDarkMode } = useTheme();
  const sliderRef = useRef();
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handlePrevClick = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.current?.slickNext();
  };

  // Slider settings with modifications
  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 19,
    slidesToScroll: 1,
    cssEase: "ease-in-out",
    swipeToSlide: true,
    variableWidth: isMobile,
    centerMode: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 18,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1699,
        settings: {
          slidesToShow: 16,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 15,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 13,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 12,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 9,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
        },
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
        },
      },
    ],
  };

  // Mobile horizontal scrolling container (no Slick)
  const MobileScrollContainer = () => (
    <div className="w-full overflow-x-auto hide-scrollbar flex gap-1 px-1 py-1 max-[350px]:gap-0.5 max-[350px]:px-0.5">
      {imgslider.map((item, index) => (
        <Link to={item.link} key={index} className="flex-shrink-0">
          <div className="cursor-pointer flex flex-col items-center px-0 w-12 max-[400px]:w-11 max-[350px]:w-10">
            <div className="flex justify-center items-center h-8 max-[400px]:h-7 max-[350px]:h-6">
              <img
                src={isDarkMode && item.darkImage ? item.darkImage : item.image}
                alt={item.name}
                className="w-8 h-8 max-[400px]:w-7 max-[400px]:h-7 max-[350px]:w-6 max-[350px]:h-6 rounded-5px"
              />
            </div>
            <div className="h-4 max-[350px]:h-3 flex items-center justify-center mt-1 max-[350px]:mt-0.5">
              <span className="block text-center text-[8px] max-[400px]:text-[7px] max-[350px]:text-[6px] leading-3 max-[350px]:leading-2 dark:text-white truncate w-full">
                {item.name}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );

  return (
    <div className="max-[420px]:overflow-hidden image-slider relative px-3 max-[400px]:px-2 max-[350px]:px-1 mb-3 max-[400px]:mb-2 max-[350px]:mb-1 mt-[-1px] dark:bg-darkblue">
      <div className="p-3 max-[400px]:p-2 max-[350px]:p-1 border border-solid rounded-[0px_0px_20px_20px] max-[350px]:rounded-[0px_0px_15px_15px] dark:bg-darktitleColor bg-lightyellow shadow-inputshadow border-yellow dark:border-[#5D6C80]">
        {/* Mobile Layout - No Grid */}
        {isMobile ? (
          <div className="w-full">
            <div className="">
              {/* <div className="image-slider-wrp"> */}
              <style>
                {`
                  .slick-dots {
                    display: none !important;
                    padding: 0 !important;
                    margin: 0 !important;
                  }
                  .slick-track {
                    display: flex;
                    align-items: center;
                    margin-left: 0 !important;
                    margin-right: 0 !important;
                  }
                  .slick-slider {
                    transition: all 0.5s ease;
                  }
                  .slick-slide {
                    transition: transform 0.5s ease;
                    padding: 0 0px;
                  }
                  .hide-scrollbar::-webkit-scrollbar {
                    display: none;
                  }
                  .hide-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                  }
                  
                  /* Extra small mobile optimizations */
                  @media (max-width: 350px) {
                    .slick-slide {
                      padding: 0 1px !important;
                    }
                  }
                `}
              </style>
              <MobileScrollContainer />
            </div>
          </div>
        ) : (
          /* Desktop Layout - With Grid and Arrows */
          <div className="max-lg:p-0 p-[0px_0px_0px_18px] grid grid-cols-12 gap-3 items-center">
            {/* Left Arrow */}
            <div className="col-span-1 flex justify-center">
              <button
                className="custom-arrow custom-prev flex justify-center items-center max-md:w-8 max-md:h-8 md:w-[38px] md:h-[38px] s18:w-12 s18:h-12 bg-yellow border-solid border-2 border-yellow rounded-5px hover:bg-transparent transition-all duration-300"
                onClick={handlePrevClick}
                aria-label="Previous"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M0.244377 8.51452L8.57678 15.7869C8.6542 15.8544 8.7461 15.908 8.84725 15.9446C8.9484 15.9812 9.05681 16 9.1663 16C9.27578 16 9.38419 15.9812 9.48534 15.9446C9.58649 15.908 9.6784 15.8544 9.75581 15.7869C9.83323 15.7193 9.89464 15.6391 9.93654 15.5508C9.97844 15.4625 10 15.3679 10 15.2724C10 15.1768 9.97844 15.0822 9.93654 14.9939C9.89464 14.9056 9.83323 14.8254 9.75581 14.7578L2.01189 8L9.75581 1.24216C9.91216 1.1057 10 0.920622 10 0.72764C10 0.534658 9.91216 0.34958 9.75581 0.213121C9.59946 0.0766618 9.38741 1.43783e-09 9.1663 0C8.94518 -1.43783e-09 8.73313 0.0766618 8.57678 0.213121L0.244377 7.48548C0.166905 7.55302 0.105446 7.63323 0.0635138 7.72151C0.0215816 7.8098 0 7.90443 0 8C0 8.09557 0.0215816 8.1902 0.0635138 8.27849C0.105446 8.36677 0.166905 8.44698 0.244377 8.51452Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>

            {/* Slider - Middle Section */}
            <div className="col-span-10">
              <div className="image-slider-wrp">
                <Slider ref={sliderRef} {...settings}>
                  {imgslider.map((imgslider, index) => (
                    <Link to={imgslider.link} key={index}>
                      <div className="cursor-pointer flex flex-col items-center px-0">
                        {/* Fixed height container for image */}
                        <div className="flex justify-center items-center h-[35px] xl:h-9 s15:h-10 s18:h-12">
                          <img
                            src={
                              isDarkMode && imgslider.darkImage
                                ? imgslider.darkImage
                                : imgslider.image
                            }
                            alt={imgslider.name}
                            className="max-[575px]:w-[35px] size-[35px] xl:size-9 s15:size-10 s18:size-12 rounded-5px"
                          />
                        </div>
                        {/* Fixed height container for text */}
                        <div className="h-6 flex items-center justify-center mt-[3px]">
                          <span className="block text-center max-md:text-[10px] text-xs leading-4 dark:text-white truncate w-full">
                            {imgslider.name}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </Slider>
              </div>
            </div>

            {/* Right Arrow */}
            <div className="col-span-1 flex justify-center">
              <button
                className="custom-arrow custom-next flex justify-center items-center max-md:w-8 max-md:h-8 md:w-[38px] md:h-[38px] s18:w-12 s18:h-12 bg-yellow border-solid border-2 border-yellow rounded-5px hover:bg-transparent transition-all duration-300"
                onClick={handleNextClick}
                aria-label="Next"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="16"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M9.75562 8.51452L1.42322 15.7869C1.3458 15.8544 1.2539 15.908 1.15275 15.9446C1.0516 15.9812 0.943187 16 0.833703 16C0.72422 16 0.615808 15.9812 0.514659 15.9446C0.413509 15.908 0.321602 15.8544 0.244186 15.7869C0.166769 15.7193 0.105359 15.6391 0.0634615 15.5508C0.021564 15.4625 0 15.3679 0 15.2724C0 15.1768 0.021564 15.0822 0.0634615 14.9939C0.105359 14.9056 0.166769 14.8254 0.244186 14.7578L7.98811 8L0.244186 1.24216C0.0878359 1.1057 -1.64741e-09 0.920622 0 0.72764C1.64741e-09 0.534658 0.0878359 0.34958 0.244186 0.213121C0.400535 0.0766618 0.612592 1.43783e-09 0.833703 0C1.05482 -1.43783e-09 1.26687 0.0766618 1.42322 0.213121L9.75562 7.48548C9.83309 7.55302 9.89455 7.63323 9.93649 7.72151C9.97842 7.8098 10 7.90443 10 8C10 8.09557 9.97842 8.1902 9.93649 8.27849C9.89455 8.36677 9.83309 8.44698 9.75562 8.51452Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Slidersection;

const imgslider = [
  { link: "/", image: home, darkImage: darkhome, name: "Home" },
  { link: "/casino", image: slider2img, darkImage: slider2img, name: "Casino" },
  {
    link: "/casino?provider=aviator",
    image: slider3img,
    darkImage: slider3img,
    name: "Aviator",
  },
  { link: "/sports", image: slider4img, darkImage: slider4img, name: "Sports" },
  {
    link: "/casino?category=PragmaticLive",
    image: slider5img,
    darkImage: slider5img,
    name: "Live Casino",
  },
  {
    link: "/game/JetX?provider=smartsoft&mode=real",
    image: slider6img,
    darkImage: slider6img,
    name: "JetX",
  },
  {
    link: "/casino?provider=aviatrix",
    image: slider7img,
    darkImage: slider7img,
    name: "Aviatrix",
  },
  {
    link: "/casino?provider=fazi",
    image: slider8img,
    darkImage: slider8img,
    name: "Fazi",
  },
  {
    link: "/casino?category=Crash",
    image: slider9img,
    darkImage: slider9img,
    name: "Crash",
  },
  {
    link: "/casino?provider=pragmaticplay",
    image: slider10img,
    darkImage: slider10img,
    name: "Pragmatic",
  },
  {
    link: "/sports",
    image: slider11img,
    darkImage: slider11img,
    name: "Jambo League",
  },
  {
    link: "/casino?provider=tada",
    image: slider12img,
    darkImage: slider12img,
    name: "Tada",
  },
  {
    link: "/casino?category=Virtuals",
    image: slider13img,
    darkImage: slider13img,
    name: "Virtuals",
  },
  {
    link: "/casino?provider=wazdan",
    image: slider14img,
    darkImage: slider14img,
    name: "Wazdan",
  },
  {
    link: "/casino?provider=playson",
    image: slider15img,
    darkImage: slider15img,
    name: "Playson",
  },
];
